export default "__VITE_ASSET__BVpZm69R__"